import { conditionLabel, provenanceLabel } from '@skop-app/lib-domain/constants'
import * as geohash from 'ngeohash'

import { matchKey } from '@/utils/matchKey.utils'

const bucketAttributes = {
  location: {
    position: 1,
    label: 'Localisations',
    value: 'location',
    type: 'map',
  },
  shopID: {
    position: 2,
    label: 'Boutiques',
    value: 'shopID',
    type: 'popup',
  },
  category: {
    position: 3,
    label: 'Catégories',
    value: 'category',
    searchable: 'true',
    type: 'table',
  },
  brand: {
    position: 4,
    label: 'Marques',
    value: 'brand',
    type: 'table',
  },
  provenance: {
    position: 5,
    label: 'Provenances',
    value: 'provenance',
    type: 'table',
    reference: provenanceLabel,
  },
  condition: {
    position: 6,
    label: 'États',
    value: 'condition',
    type: 'table',
    reference: conditionLabel,
  },
  action: {
    position: 7,
    label: 'Statuts',
    value: 'action',
    type: 'table',
  },
  type: {
    position: 8,
    label: 'Types',
    value: 'type',
    type: 'table',
  },
}

const formatKey = (type, key) => {
  switch (type) {
    case 'provenance':
      return matchKey(key, provenanceLabel)?.label
    case 'condition':
      return matchKey(key, conditionLabel)?.label
    case 'location': {
      const latlon = geohash.decode(key)
      return {
        lat: latlon.latitude,
        lon: latlon.longitude,
      }
    }
    default:
      return key
  }
}

export const bucketsAdapter = (aggregateItems) => {
  const buckets = aggregateItems.map((item) => {
    const attributes = bucketAttributes[item.name] ?? {
      value: 'Missing Attributes ' + item.name,
      key: item.name,
    }
    const items = item.result.buckets.map((bucket) => {
      return {
        label: formatKey(attributes.value, bucket.key),
        value: bucket.key,
        count: bucket.doc_count,
      }
    })
    return {
      ...attributes,
      items: items.filter((item) => item.label),
    }
  })

  return buckets.sort((a, b) => a.position - b.position)
}
